import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  GET_SIGNATORY_INFO,
  AUTHORIZE_SIGNATORY,
  getSignatoryInfoSuccess,
  getSignatoryInfoFail,
  authorizeSignatorySuccess,
  authorizeSignatoryFail
} from "../actions/getSignatoryInfo";
import { getSignatories, authorizeSignatory } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { getAuthorizationHeader } from "../selectors/appConfig";

export function* getSignatoriesSaga({ payload }) {
  try {
    const state = yield select();
    const headers = getAuthorizationHeader(state);
    const { prospectId, signatoryId } = payload;

    const response = yield call(getSignatories.get, headers, prospectId, signatoryId);

    yield put(getSignatoryInfoSuccess(response.data));
  } catch (error) {
    log(error);
    yield put(getSignatoryInfoFail());
  }
}
export function* authorizeSignatorySaga({ payload }) {
  try {
    const state = yield select();
    const headers = getAuthorizationHeader(state);
    yield call(authorizeSignatory.authorize, headers, payload);

    yield put(authorizeSignatorySuccess());
  } catch (error) {
    log(error);
    yield put(authorizeSignatoryFail());
  }
}

export default function* getSignatoriesSagas() {
  yield all([takeLatest(GET_SIGNATORY_INFO, getSignatoriesSaga)]);
  yield all([takeLatest(AUTHORIZE_SIGNATORY, authorizeSignatorySaga)]);
}
